module.exports = __webpack_public_path__ + "static/media/POST CONSTRUCTION .e86b4de0.jpg";